import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MaintenanceDialogComponent, MaintenanceDialogData } from '../components/maintenance-dialog/maintenance-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  constructor(
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  /**
   * Show maintenance dialog if not already dismissed
   * @param titleKey - Translation key for the maintenance title
   * @param messageKey - Translation key for the maintenance message
   * @param storageKey - Unique key for localStorage to track dismissal
   */
  showMaintenanceDialog(titleKey: string, messageKey: string, storageKey: string): void {
    // Only run in browser (not during SSR)
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const isDismissed = localStorage.getItem(storageKey);

    if (!isDismissed) {
      this.dialog.open(MaintenanceDialogComponent, {
        data: {
          titleKey,
          messageKey,
          storageKey
        } as MaintenanceDialogData,
        panelClass: 'maintenance-dialog-container',
        disableClose: false,
        maxWidth: '100vw',
        maxHeight: '100vh',
        autoFocus: false
      });
    }
  }

  /**
   * Clear the dismissed state for a maintenance message
   * Useful for testing or when you want to show the message again
   */
  clearDismissedState(storageKey: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(storageKey);
    }
  }
}
